(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5738],{

/***/ 67394:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Batch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Batch"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batchNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manualScrap"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plannedStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":144}}');
    doc.loc.source = JSON.parse('{"body":"fragment Batch on Batch {\\n  batchId\\n  batchNumber\\n  state\\n  amount\\n  manualScrap\\n  plannedStart\\n  actualStart\\n  actualStop\\n  comment\\n  lineId\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 50619:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validatedLineSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedAverageSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataMultiplier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":181}}');
    doc.loc.source = JSON.parse('{"body":"fragment Product on Product {\\n  productId\\n  name\\n  itemNumber\\n  lineId\\n  validatedLineSpeed\\n  expectedAverageSpeed\\n  dataMultiplier\\n  comment\\n  parameters {\\n    key\\n    value\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 27112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68355);
/* harmony import */ var _mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72795);
/* harmony import */ var _mui_material_ButtonBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65453);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71601);









var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()({
    fadeScrollButton: {
        color: "rgba(0, 0, 0, .1)"
    },
    scrollButton: {
        width: 56,
        flexShrink: 0
    }
});
var ScrollButton = function(props) {
    var className = props.className, onClick = props.onClick, direction = props.direction, visible = props.visible, disabled = props.disabled, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "className",
        "onClick",
        "direction",
        "visible",
        "disabled"
    ]);
    var ref = useStyles(), classes = ref.classes, cx = ref.cx;
    var classNames = disabled ? cx(!visible && classes.fadeScrollButton, classes.scrollButton, className) : cx(classes.scrollButton, className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_ButtonBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: classNames,
        onClick: onClick,
        tabIndex: -1,
        disabled: disabled
    }, other), {
        children: direction === "left" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            fontSize: "large"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            fontSize: "large"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollButton);


/***/ }),

/***/ 23237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53888);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35192);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _hocs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96895);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79857);










var styles = function() {
    return {
        small: {
            height: "2em",
            width: "100%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    };
};
var Box = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Box, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Box);
    function Box() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Box);
        return _super.apply(this, arguments);
    }
    var _proto = Box.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, className = _props.className, small = _props.small, backgroundColor = _props.backgroundColor, _cardContentClass = _props.cardContentClass, cardContentClass = _cardContentClass === void 0 ? "" : _cardContentClass;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            elevation: 1,
            className: className,
            style: {
                backgroundColor: backgroundColor ? backgroundColor : "#ffffff"
            },
            children: small ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.small,
                children: this.props.children
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: cardContentClass,
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: this.props.children
            })
        });
    };
    return Box;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)(_hocs__WEBPACK_IMPORTED_MODULE_8__/* .withUtils */ .W, (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__/* .withStyles */ .D)(styles));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(Box));


/***/ }),

/***/ 69538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(426);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49692);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53486);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71601);








var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_1__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(2),
            backgroundColor: "#f7f7f7"
        },
        /* Styles applied to the action element. */ action: {
            flex: "0 0 auto",
            alignSelf: "center"
        },
        /* Styles applied to the content wrapper element. */ content: {
            flex: "1 1 auto"
        }
    };
});
var DialogHeader = function(_param) {
    var action = _param.action, title = _param.title, onClose = _param.onClose, _children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "action",
        "title",
        "onClose",
        "children"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: classes.content
            }, props), {
                children: title
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.action,
                children: [
                    action,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        id: "closeDialog",
                        onClick: onClose,
                        size: "large",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            fontSize: "small"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DialogHeader);


/***/ }),

/***/ 45831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_RingVolume__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89464);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1827);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88665);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38429);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14517);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15506);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _components_card_box__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23237);
/* harmony import */ var _hocs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(96895);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(79857);
/* harmony import */ var _lib_stop_type_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63220);


















var styles = function(theme) {
    return {
        // TODO: Re-factor this, it's used in the Andon overview as well.
        "@keyframes pulseUrgencyCritical": {
            "0%": {
                color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"][800] */ .Z[800]
            },
            "50%": {
                color: "inherit"
            },
            "100%": {
                color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"][800] */ .Z[800]
            }
        },
        "@keyframes pulseUrgencyMedium": {
            "0%": {
                color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"][600] */ .Z[600]
            },
            "50%": {
                color: "inherit"
            },
            "100%": {
                color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"][600] */ .Z[600]
            }
        },
        buttonUrgencyCritical: {
            animationName: "$pulseUrgencyCritical"
        },
        buttonUrgencyMedium: {
            animationName: "$pulseUrgencyMedium"
        },
        andonIndicator: {
            marginLeft: "1em",
            fontSize: "inherit",
            color: "inherit",
            animationIterationCount: "infinite",
            animationDuration: "3s"
        },
        cardContentClass: {
            padding: "0 !important",
            paddingBottom: "0px !important"
        }
    };
};
var LineStatus = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(LineStatus, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(LineStatus);
    function LineStatus() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, LineStatus);
        return _super.apply(this, arguments);
    }
    var _proto = LineStatus.prototype;
    _proto.render = function render() {
        var _props = this.props, className = _props.className, moreStyle = _props.moreStyle, _lineStatus = _props.lineStatus, statusText = _lineStatus.statusText, statusColor = _lineStatus.statusColor, lineDuration = _lineStatus.lineDuration, unresolvedCall = _lineStatus.unresolvedCall, small = _props.small, utils = _props.utils, sensorType = _props.sensorType, t = _props.t, theme = _props.theme, classes = _props.classes, _wide = _props.wide, wide = _wide === void 0 ? true : _wide;
        var stopText = statusText;
        if ((0,_lib_stop_type_names__WEBPACK_IMPORTED_MODULE_8__/* .stopTypeNames */ .R)(t)[statusText]) {
            stopText = (0,_lib_stop_type_names__WEBPACK_IMPORTED_MODULE_8__/* .stopTypeNames */ .R)(t)[statusText];
        }
        var showDuration = true;
        if (sensorType === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_9__/* .SensorType.MEASUREMENT */ .dE.MEASUREMENT) {
            showDuration = false;
        }
        var hasNeverBeenOnline = false;
        var durationString = null;
        try {
            // If it has never been online since 2000-01-01, then it has literally never been online.
            var now = new Date().getTime();
            if (new Date(now - lineDuration) < new Date("2000-01-01")) {
                hasNeverBeenOnline = true;
            }
        } catch (_err) {}
        if (!hasNeverBeenOnline) {
            var lineDurationDays = lineDuration - lineDuration % (24 * 3600 * 1000);
            var lineDurationHours = lineDuration - lineDurationDays - lineDuration % (3600 * 1000);
            var lineDurationMinutes = lineDuration - lineDurationDays - lineDurationHours - lineDuration % (1000 * 60);
            var lineDurationSeconds = lineDuration - lineDurationDays - lineDurationHours - lineDurationMinutes - lineDuration % 1000;
            var lineDurationMiliseconds = lineDuration - lineDurationDays - lineDurationHours - lineDurationMinutes - lineDurationSeconds - lineDuration;
            if (lineDuration < 1000) {
                durationString = lineDurationMiliseconds ? utils.formatDistanceStrict(0, lineDurationMiliseconds / 1000, {
                    roundingMethod: "floor",
                    unit: "second"
                }) : "";
            } else if (lineDuration < 60000) {
                durationString = lineDurationSeconds ? utils.formatDistanceStrict(0, lineDurationSeconds, {
                    roundingMethod: "floor",
                    unit: "second"
                }) : "";
            } else {
                durationString = [
                    lineDurationDays ? utils.formatDistanceStrict(0, lineDurationDays, {
                        roundingMethod: "floor",
                        unit: "day"
                    }) : "",
                    lineDurationHours ? utils.formatDistanceStrict(0, lineDurationHours, {
                        roundingMethod: "floor",
                        unit: "hour"
                    }) : "",
                    lineDurationMinutes && (!unresolvedCall || wide) ? utils.formatDistanceStrict(0, lineDurationMinutes, {
                        roundingMethod: "floor",
                        unit: "minute"
                    }) : "", 
                ].filter(function(value) {
                    return value;
                }).join(", ");
            }
        } else {
            durationString = t([
                "shared:forever"
            ], {
                defaultValue: "Forever"
            });
        }
        var _obj;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_card_box__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            small: small,
            backgroundColor: statusColor,
            className: className,
            cardContentClass: classes.cardContentClass,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                className: className,
                variant: "body2",
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                    justifyContent: "center",
                    alignItems: "center",
                    color: theme.palette.getContrastText(statusColor)
                }, moreStyle),
                noWrap: true,
                children: [
                    " ".concat(stopText, " "),
                    showDuration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            durationString ? " - " : "",
                            durationString
                        ]
                    }),
                    !!unresolvedCall ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_RingVolume__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__["default"])(classes.andonIndicator, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, classes.buttonUrgencyCritical, unresolvedCall === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_9__/* .Urgency.CRITICAL */ .Tj.CRITICAL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, classes.buttonUrgencyMedium, unresolvedCall === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_9__/* .Urgency.MEDIUM */ .Tj.MEDIUM), _obj))
                    }) : null
                ]
            })
        });
    };
    return LineStatus;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .withTranslation */ .Z)([
    "shared"
]), _hocs__WEBPACK_IMPORTED_MODULE_17__/* .withUtils */ .W, (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__/* .withStyles */ .D)(styles, {
    withTheme: true
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(LineStatus));


/***/ }),

/***/ 77741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Undo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96498);
/* harmony import */ var _mui_material_Tab__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84029);
/* harmony import */ var _mui_material_Tabs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43040);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82672);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71601);
/* harmony import */ var _components_buttons_scroll_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27112);
/* harmony import */ var _components_pickers_date_time_range_picker__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48744);
/* harmony import */ var _components_selected_time_range__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64641);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59671);
/* harmony import */ var _contexts_timepicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76381);














var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    var _obj;
    return {
        timeSelector: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            overflow: "visible",
            minWidth: 60,
            maxWidth: 60
        }, theme.breakpoints.down("sm"), {
            minWidth: 45,
            maxWidth: 45
        }),
        customTimeIcon: {
            height: "16px"
        },
        timePickerTabs: {
            overflow: "hidden",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
                width: "0 !important"
            }
        },
        tabsScroller: {
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
                width: "0 !important"
            }
        },
        timePickerSelectedTime: (_obj = {
            marginLeft: "1em"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("sm"), {
            textAlign: "center"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("lg"), {
            marginTop: "0.5em"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("lg"), {
            marginTop: "1em"
        }), _obj),
        flex: {
            flex: 1,
            overflow: "hidden",
            marginTop: theme.spacing(-1)
        },
        hiddenOnMobile: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.breakpoints.down("sm"), {
            display: "none"
        }),
        hidden: {
            minWidth: 60,
            maxWidth: 60,
            visibility: "hidden"
        }
    };
});
var TimePicker = function(param) {
    var _hideSelected = param.hideSelected, hideSelected = _hideSelected === void 0 ? false : _hideSelected, includeLargeRanges = param.includeLargeRanges, _showCustomTimePicker = param.showCustomTimePicker, showCustomTimePicker = _showCustomTimePicker === void 0 ? true : _showCustomTimePicker, _showUndo = param.showUndo, showUndo = _showUndo === void 0 ? true : _showUndo;
    var ref = (0,_contexts_timepicker__WEBPACK_IMPORTED_MODULE_4__/* .useTimePicker */ .AV)(), from = ref.from, to = ref.to, setTime = ref.setTime, historySize = ref.historySize, undo = ref.undo, relativeTimeInterval = ref.relativeTimeInterval;
    var classes = useStyles().classes;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)([
        "shared"
    ]), 1), t = ref1[0];
    var calendarIconRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref2[0], setOpen = ref2[1];
    var filteredTimeSelectionIntervals = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return _contexts_timepicker__WEBPACK_IMPORTED_MODULE_4__/* .timeSelectionIntervals.filter */ .PZ.filter(function(param) {
            var largeRange = param.largeRange;
            return largeRange === undefined || includeLargeRanges && largeRange === true;
        });
    }, [
        includeLargeRanges
    ]);
    var onTimeSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(_, v) {
        var selectedTimeInterval = filteredTimeSelectionIntervals[Number(v)];
        if (!selectedTimeInterval) {
            return;
        }
        setTime(new Date(Date.now() - selectedTimeInterval.time), null);
    }, [
        setTime,
        filteredTimeSelectionIntervals
    ]);
    var onClickCalendarIcon = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setOpen(true);
    }, [
        setOpen
    ]);
    var onClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setOpen(false);
    }, [
        setOpen
    ]);
    var onCalendarSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(start, end) {
        setTime(start, end);
        onClose();
    }, []);
    var numSelectableTabs = filteredTimeSelectionIntervals.length + 1;
    // relativeTimeInverval is not 100% exact, so +-1 second
    var value = (filteredTimeSelectionIntervals.findIndex(function(param) {
        var time = param.time;
        return relativeTimeInterval && Math.abs(relativeTimeInterval - time) < 1000;
    }) % numSelectableTabs + numSelectableTabs) % numSelectableTabs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.flex,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Tabs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                indicatorColor: "primary",
                className: classes.timePickerTabs,
                classes: {
                    scroller: classes.tabsScroller
                },
                value: value,
                onChange: onTimeSelect,
                variant: "scrollable",
                scrollButtons: "auto",
                ScrollButtonComponent: _components_buttons_scroll_button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                allowScrollButtonsMobile: true,
                children: [
                    filteredTimeSelectionIntervals.map(function(param) {
                        var label = param.label;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            className: classes.timeSelector,
                            label: t([
                                "shared:".concat(label)
                            ], {
                                defaultValue: label
                            })
                        }, label);
                    }),
                    showCustomTimePicker && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        className: classes.timeSelector,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_constants__WEBPACK_IMPORTED_MODULE_10__/* .CALENDAR_PICKER_ICON */ .NR, {
                            className: classes.customTimeIcon
                        }),
                        ref: calendarIconRef,
                        onClick: onClickCalendarIcon
                    }, "custom"),
                    showUndo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        className: !!historySize ? classes.timeSelector : classes.hidden,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Undo__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: classes.customTimeIcon
                        }),
                        onClick: undo
                    }, "time-history")
                ]
            }),
            !hideSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_selected_time_range__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pickers_date_time_range_picker__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                anchorEl: calendarIconRef.current,
                disableFuture: true,
                from: from,
                to: to || new Date(),
                open: open,
                closePicker: onClose,
                setTime: onCalendarSelect,
                range: true,
                showTabs: true
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TimePicker);


/***/ }),

/***/ 78591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53888);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1827);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79857);










var styles = function() {
    return {
        progressContainer: {
            height: "2em",
            width: "100%",
            position: "relative",
            border: "1px solid black"
        },
        smallProgressContainer: {
            height: "2em",
            width: "100%",
            position: "relative",
            border: "none",
            display: "flex",
            alignItems: "center"
        },
        progressText: {
            position: "absolute",
            top: "50%",
            marginTop: "-1em",
            width: "100%",
            textAlign: "center"
        },
        smallProgressText: {
            position: "absolute",
            width: "100%",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        smallInlineProgressText: {
            position: "absolute",
            width: "100%",
            display: "flex"
        },
        progressBarRed: {
            "&:after": {
                backgroundColor: "#ff5b5b",
                filter: "invert(1)"
            }
        },
        progressBarGreen: {
            "&:after": {
                backgroundColor: "#43a047",
                filter: "invert(1)",
                willChange: "opacity"
            }
        },
        progressBar: {
            height: "100%",
            position: "relative",
            width: "0%",
            transition: "1s width",
            "&:before, &:after": {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                position: "absolute",
                content: '""'
            },
            "&:before": {
                zIndex: 1,
                pointerEvents: "none",
                mixBlendMode: "difference",
                backgroundColor: "white"
            }
        },
        // Chrome, Safari, new Chrome-based Edge Browser and Firefox
        "@supports (-ms-ime-align:auto)": {
            progressBar: {
                "&:before": {
                    // Because mixBlendMode does not work in Edge, we need to disable the background color for Edge only.
                    backgroundColor: "transparent"
                }
            }
        },
        batchText: {
            fontSize: 20,
            marginBottom: "12px",
            textAlign: "center",
            width: "100%"
        },
        smallBatchText: {
            fontSize: "0.875rem",
            marginBottom: "0",
            textAlign: "center",
            width: "100%"
        }
    };
};
var Progress = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Progress, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Progress);
    function Progress() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Progress);
        return _super.apply(this, arguments);
    }
    var _proto = Progress.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, left = _props.left, right = _props.right, inlineTitle = _props.inlineTitle, completePercentage = _props.completePercentage, small = _props.small, _red = _props.red, red = _red === void 0 ? false : _red;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            elevation: 1,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: small ? classes.smallProgressContainer : classes.progressContainer,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            width: "".concat(Math.min(100, completePercentage), "%")
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__["default"])(classes.progressBar, red ? classes.progressBarRed : classes.progressBarGreen)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: small ? classes.smallProgressText : classes.progressText,
                        children: inlineTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "body2",
                            className: small ? classes.smallBatchText : classes.batchText,
                            noWrap: true,
                            children: [
                                inlineTitle + ": ",
                                left,
                                " ",
                                left !== "" ? "/" : "",
                                " ",
                                right,
                                " "
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "body2",
                            className: small ? classes.smallBatchText : classes.batchText,
                            noWrap: true,
                            children: [
                                " ",
                                left,
                                " ",
                                left !== "" ? "/" : "",
                                " ",
                                right,
                                " "
                            ]
                        })
                    })
                ]
            })
        });
    };
    return Progress;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__/* .withStyles */ .D)(styles));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(Progress));


/***/ }),

/***/ 64641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62523);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1827);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32382);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15506);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71601);
/* harmony import */ var _contexts_timepicker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76381);
/* harmony import */ var _graphql_queries__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59964);
/* harmony import */ var _graphql_queries__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_graphql_queries__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _helpers_helper_functions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51843);
/* harmony import */ var _helpers_schedule__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27261);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17094);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49896);















var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    var _obj;
    return {
        range: {
            fontSize: "75%",
            color: theme.palette.grey.A400
        },
        timeSelector: {
            minWidth: 60,
            maxWidth: 60
        },
        selectedTimeText: {
            color: theme.palette.primary.main
        },
        timePickerSelectedTime: (_obj = {
            marginLeft: "1em"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("sm"), {
            textAlign: "center"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("lg"), {
            marginTop: "0.5em"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("lg"), {
            marginTop: "1em"
        }), _obj),
        hiddenOnMobile: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.breakpoints.down("sm"), {
            display: "none"
        })
    };
});
var SelectedTimeRange = function() {
    var ref, ref1, ref2;
    var classes = useStyles().classes;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)([
        "shared"
    ]), 2), t = ref3[0], i18n = ref3[1];
    var ref4 = (0,_contexts_timepicker__WEBPACK_IMPORTED_MODULE_6__/* .useTimePicker */ .AV)(), from = ref4.from, to = ref4.to;
    var lineId = (0,_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useLine */ .I)().lineId;
    var isPrint = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("@media print");
    var currentDate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return new Date();
    }, [
        from,
        to
    ]);
    var nowFilter = (0,_helpers_schedule__WEBPACK_IMPORTED_MODULE_9__/* .getYearWeek */ .dl)(currentDate);
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_10__.useLazyQuery)((_graphql_queries__WEBPACK_IMPORTED_MODULE_11___default()), {
        ssr: false,
        partialRefetch: true,
        variables: {
            lineId: lineId,
            validIn: nowFilter
        }
    }), 2), getShifts = ref5[0], ref6 = ref5[1], nextData = ref6.data, previousData = ref6.previousData;
    var data = nextData || previousData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!lineId) {
            return;
        }
        if (!isPrint) {
            return;
        }
        getShifts();
    }, [
        lineId,
        isPrint
    ]);
    var ref7;
    var startDay = (ref7 = (ref = data === null || data === void 0 ? void 0 : data.line.schedule) === null || ref === void 0 ? void 0 : (ref1 = ref.configuration) === null || ref1 === void 0 ? void 0 : ref1.startDayOfWeek) !== null && ref7 !== void 0 ? ref7 : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_12__/* .DayOfWeek.MONDAY */ .eO.MONDAY;
    var perfectlyAlignedShift = (ref2 = data === null || data === void 0 ? void 0 : data.line.schedule) === null || ref2 === void 0 ? void 0 : ref2.shifts.find(function(shift) {
        if (!to) {
            return false;
        }
        var ref = (0,_helpers_schedule__WEBPACK_IMPORTED_MODULE_9__/* .convertGenericShiftTimeToDatePair */ .VL)(shift.timeRange, currentDate, startDay), startDate = ref.from, endDate = ref.to;
        return from.getTime() === startDate.getTime() && to.getTime() === endDate.getTime();
    });
    var alignedSelection = perfectlyAlignedShift ? "".concat((0,_helpers_schedule__WEBPACK_IMPORTED_MODULE_9__/* .getDayStringOfEnum */ .g_)(t, perfectlyAlignedShift.timeRange.from.day), ": ").concat(perfectlyAlignedShift.name) : "";
    if (isPrint) {
        var terminatingText = to ? (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_13__/* .timeFormathhmm */ .pU)(to, i18n.language) : (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_13__/* .timeFormatyyyyMMdhmm */ .td)(currentDate, i18n.language);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            variant: "h6",
            children: [
                alignedSelection ? "".concat(alignedSelection, " ") : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: classes.range,
                    children: [
                        (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_13__/* .timeFormatyyyyMMdhmm */ .td)(from, i18n.language),
                        " – ",
                        terminatingText
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        className: classes.timePickerSelectedTime,
        variant: "body2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classes.hiddenOnMobile,
                children: [
                    t([
                        "shared:selected"
                    ], {
                        defaultValue: "Selected"
                    }),
                    ": "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes.selectedTimeText,
                children: (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_13__/* .timeFormatyyyyMMdhmm */ .td)(from, i18n.language)
            }),
            " ",
            t([
                "shared:to"
            ], {
                defaultValue: "to"
            }).toLowerCase(),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes.selectedTimeText,
                children: to ? (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_13__/* .timeFormatyyyyMMdhmm */ .td)(to, i18n.language) : t([
                    "shared:now"
                ], {
                    defaultValue: "now"
                }).toLowerCase()
            }),
            " ",
            alignedSelection ? "(".concat(alignedSelection, ")") : ""
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectedTimeRange);


/***/ }),

/***/ 41181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LineContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);

var LineContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    lineId: undefined,
    lineName: undefined
});


/***/ }),

/***/ 76381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ useTimePicker; },
/* harmony export */   "PZ": function() { return /* binding */ timeSelectionIntervals; },
/* harmony export */   "hg": function() { return /* binding */ TimePickerProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48417);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _blackbird_ui_base_contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30495);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95840);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29901);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10571);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39106);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90485);










var timeSelectionIntervals = [
    {
        time: 30..minutes,
        label: "30m"
    },
    {
        time: 60..minutes,
        label: "1h"
    },
    {
        time: 4..hours,
        label: "4h"
    },
    {
        time: 8..hours,
        label: "8h"
    },
    {
        time: 12..hours,
        label: "12h"
    },
    {
        time: 24..hours,
        label: "24h"
    },
    {
        time: 2 * 24..hours,
        label: "48h"
    },
    {
        time: 7 * 24..hours,
        label: "1w"
    },
    {
        time: 30 * 24..hours,
        label: "1m",
        largeRange: true
    }, 
];
var _timeSelectionIntervals = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(timeSelectionIntervals, 3), ref = _timeSelectionIntervals[2], defaultInterval = ref.time;
var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_blackbird_ui_base_contexts__WEBPACK_IMPORTED_MODULE_1__/* .createContextHook */ .TR)(), 2);
var TimePickerProvider = ref1[0], useTimePicker = ref1[1];
var TimepickerContextWrapper = function(param) {
    var children = param.children;
    var _ref = (0,_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useURLQuery */ .m)(), tmp = _ref.from, queryFrom = tmp === void 0 ? "" : tmp, tmp1 = _ref.to, queryTo = tmp1 === void 0 ? "" : tmp1, restQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, [
        "from",
        "to"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return [
            new Date(queryFrom).getTime() || NaN,
            new Date(queryTo).getTime() || NaN
        ];
    }, [
        queryFrom,
        queryTo
    ]), queryFromMillis = ref[0], queryToMillis = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(queryFromMillis || Date.now() - 8..hours), from = ref1[0], setFrom = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(queryFromMillis < queryToMillis ? queryToMillis : null), to = ref2[0], setTo = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), history = ref3[0], setHistory = ref3[1];
    var relativeTimeInterval = to ? null : Date.now() - from;
    var setTime = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(start, end) {
        // Ensures from and to are updated at the same time. May be removed in future React versions. https://stackoverflow.com/questions/48563650/does-react-keep-the-order-for-state-updates/48610973#48610973
        (0,react_dom__WEBPACK_IMPORTED_MODULE_4__.unstable_batchedUpdates)(function() {
            setFrom(start.getTime());
            setTo(end && start.getTime() < end.getTime() ? end.getTime() : null);
            setHistory((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(history).concat([
                {
                    from: from,
                    to: to
                }
            ]).slice(-10));
        });
    }, [
        history
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        // Ensures from and to are updated at the same time. May be removed in future React versions. https://stackoverflow.com/questions/48563650/does-react-keep-the-order-for-state-updates/48610973#48610973
        (0,react_dom__WEBPACK_IMPORTED_MODULE_4__.unstable_batchedUpdates)(function() {
            if (queryFromMillis && queryFromMillis !== from) {
                setFrom(queryFromMillis);
            }
            if (queryToMillis && queryToMillis !== to) {
                setTo(queryToMillis);
            }
        });
    }, [
        queryFromMillis,
        queryToMillis
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var newFrom = queryFromMillis !== from;
        var newTo = queryToMillis !== to;
        if (!newFrom && !newTo) {
            return;
        }
        var pathname = router.pathname;
        var url = (0,url__WEBPACK_IMPORTED_MODULE_5__.format)({
            pathname: pathname,
            query: [
                {
                    from: from
                },
                {
                    to: to
                }
            ].reduce(function(query, timestamp) {
                var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Object.entries(timestamp), 1), ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ref[0], 2), key = ref1[0], value = ref1[1];
                if (value) {
                    query[key] = new Date(value).toISOString();
                }
                return query;
            }, restQuery)
        });
        router.replace(url, url, {
            shallow: true
        });
    }, [
        from,
        to
    ]);
    var undo = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        if (!history.length) {
            return;
        }
        var cutOff = history.length - 1;
        var ref = [
            history.slice(0, cutOff),
            history.slice(cutOff)
        ], nextHistory = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ref[1], 1), historyItem = ref1[0];
        // Ensures from and to are updated at the same time. May be removed in future React versions. https://stackoverflow.com/questions/48563650/does-react-keep-the-order-for-state-updates/48610973#48610973
        (0,react_dom__WEBPACK_IMPORTED_MODULE_4__.unstable_batchedUpdates)(function() {
            setHistory(nextHistory);
            if (!historyItem) {
                return;
            }
            setFrom(historyItem.from);
            setTo(historyItem.to);
        });
        return historyItem.from;
    }, [
        history
    ]);
    var futureTimeSpan = Math.max(0, (to || 0) - Date.now());
    var fromDate = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return new Date(from);
    }, [
        from,
        futureTimeSpan
    ]);
    var toDate = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return to ? new Date(to) : null;
    }, [
        to,
        futureTimeSpan
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TimePickerProvider, {
        value: {
            from: fromDate,
            to: toDate,
            setTime: setTime,
            historySize: history.length,
            undo: undo,
            relativeTimeInterval: relativeTimeInterval
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (TimepickerContextWrapper);


/***/ }),

/***/ 67337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ withIAM; },
/* harmony export */   "y": function() { return /* binding */ withIAMPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74486);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6203);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53888);
/* harmony import */ var _mui_material_CardActions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(63557);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35192);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27908);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1827);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67223);
/* harmony import */ var _contexts_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74424);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(79857);
/* harmony import */ var _hooks_use_iam__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87325);
/* harmony import */ var _lib_features__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17441);





















// FIXME: Correct the user context signature...
// tslint:disable:max-classes-per-file
var withIAM = function(WrappedComponent) {
    return /*#__PURE__*/ function(_Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMWrapper, _Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMWrapper);
        function WithIAMWrapper() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMWrapper);
            return _super.apply(this, arguments);
        }
        var _proto = WithIAMWrapper.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                children: function(user) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        user: user,
                        features: user.features,
                        hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                        hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                        hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                        hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features),
                        hasFeatureInAnyUserPool: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features),
                        hasModuleAccess: (0,_hooks_use_iam__WEBPACK_IMPORTED_MODULE_10__/* .makeModuleAccessChecker */ .j)(user.claims)
                    }, _this.props));
                }
            });
        };
        return WithIAMWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
};
var styles = function(theme) {
    return {
        card: {
            width: "100%",
            maxWidth: "500px"
        },
        fillHeight: {
            height: "100%"
        },
        title: {
            marginBottom: theme.spacing(2)
        }
    };
};
var withIAMPage = function(lookupFeatures, featureType) {
    var scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "group";
    return function(WrappedComponent) {
        var WithIAMPageWrapper = /*#__PURE__*/ function(_Component) {
            "use strict";
            (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMPageWrapper, _Component);
            var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMPageWrapper);
            function WithIAMPageWrapper() {
                (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMPageWrapper);
                return _super.apply(this, arguments);
            }
            var _proto = WithIAMPageWrapper.prototype;
            _proto.render = function render() {
                var _props = this.props, classes = _props.classes, t = _props.t, i18n = _props.i18n, tReady = _props.tReady, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_props, [
                    "classes",
                    "t",
                    "i18n",
                    "tReady"
                ]);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                    children: function(_param) {
                        var status = _param.status, user = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
                            "status"
                        ]);
                        var allowed = scope === "userPool" ? _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features)(lookupFeatures, featureType) : _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features)(lookupFeatures, featureType);
                        var wrappedMessage;
                        if (!status.loading && user && user.features && !allowed) {
                            wrappedMessage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                className: classes.fillHeight,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                    container: true,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    className: classes.fillHeight,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.card,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            variant: "h5",
                                                            className: classes.title,
                                                            children: t([
                                                                "shared:unfortunatelyNoPermission"
                                                            ], {
                                                                defaultValue: "Unfortunately, you don't have permission to view this page!"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            children: t([
                                                                "shared:contactYourLocalAdminIfWrong"
                                                            ], {
                                                                defaultValue: "If you believe this is a mistake, contact your local administrator, and they can grant you access."
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardActions__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                                        href: {
                                                            pathname: "/"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                            color: "primary",
                                                            children: t([
                                                                "shared:returnToFrontPage"
                                                            ], {
                                                                defaultValue: "Return to front page"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            });
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            loading: status.loading,
                            error: status.error,
                            wrappedMessage: wrappedMessage,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                                features: user.features,
                                hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                                hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                                hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                                hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features),
                                hasModuleAccess: (0,_hooks_use_iam__WEBPACK_IMPORTED_MODULE_10__/* .makeModuleAccessChecker */ .j)(user.claims)
                            }, restProps))
                        });
                    }
                });
            };
            return WithIAMPageWrapper;
        }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
        var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_19__/* .withTranslation */ .Z)([
            "shared"
        ]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_20__/* .withStyles */ .D)(styles));
        return enhance(WithIAMPageWrapper);
    };
};


/***/ }),

/***/ 99560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _stop_type_names__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63220);

var translateStoptypename = function(t, lineCause) {
    if ((0,_stop_type_names__WEBPACK_IMPORTED_MODULE_0__/* .stopTypeNames */ .R)(t)[lineCause]) {
        return (0,_stop_type_names__WEBPACK_IMPORTED_MODULE_0__/* .stopTypeNames */ .R)(t)[lineCause];
    } else {
        return lineCause;
    }
};
var getLineStatusInfo = function(t, theme, lineStatus, lineDuration, stopRegisterThresholdInMillis, lineCause, unresolvedCall) {
    switch(lineStatus){
        case "OFF":
            return {
                statusColor: "#8e24aa",
                statusText: t([
                    "batches:statusOffline"
                ], {
                    defaultValue: "Offline"
                }),
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        case "DOWNTIME":
            if (lineDuration >= stopRegisterThresholdInMillis) {
                return {
                    statusColor: "#d32f2f",
                    statusText: translateStoptypename(t, lineCause),
                    lineDuration: lineDuration,
                    unresolvedCall: unresolvedCall
                };
            } else {
                return {
                    statusColor: "#43a047",
                    statusText: t([
                        "batches:statusPending"
                    ], {
                        defaultValue: "Pending"
                    }),
                    lineDuration: lineDuration,
                    unresolvedCall: unresolvedCall
                };
            }
        case "NO_ACT":
            return {
                statusColor: theme.blackbird.stops.NO_ACT.color.main,
                statusText: lineCause,
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        case "NON_PROD":
            return {
                statusColor: "#62757f",
                statusText: lineCause,
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        case "BATCH_NON_PROD":
            return {
                statusColor: theme.blackbird.stops.BATCH_NON_PROD.color.main,
                statusText: lineCause,
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        case "RUNNING":
            return {
                statusColor: "#43a047",
                statusText: t([
                    "batches:statusRunning"
                ], {
                    defaultValue: "Running"
                }),
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        default:
            return {
                statusColor: "#fff",
                statusText: "",
                lineDuration: 0,
                unresolvedCall: unresolvedCall
            };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getLineStatusInfo);


/***/ }),

/***/ 63220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ stopTypeNames; }
/* harmony export */ });
var stopTypeNames = function(t) {
    return {
        DOWNTIME: t([
            "stop:lossDuringOperation"
        ], {
            defaultValue: "Loss During Operation"
        }),
        NO_ACT: t([
            "stop:noActivityAtLine"
        ], {
            defaultValue: "No Activity at Line"
        }),
        NON_PROD: t([
            "stop:nonProductionActivities"
        ], {
            defaultValue: "Non-production Activities"
        }),
        BATCH_NON_PROD: t([
            "stop:batchSpecificNonOperation"
        ], {
            defaultValue: "Batch-specific Non-operation"
        }),
        UNREGISTERED: t([
            "shared:unregistered"
        ], {
            defaultValue: "Unregistered"
        }),
        MICRO_STOP: t([
            "shared:microStop"
        ], {
            defaultValue: "Micro stop"
        })
    };
};


/***/ })

}]);